// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <v-container fluid grid-list-md>
    <v-row wrap>
      <v-col cols="12" justify-center>
        <item-list
        allowAdd
        allowDelete
        :endpoint="endpoint + 'users'"
        editRoute="userEdit"
        :headers="headers"
        name="User"
        :searchBarText="searchBarText"
        permissions="users"
        ></item-list>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {ENDPOINT} from '@/shared/constants'
import ItemList from 'vue-common/components/ItemList.vue'

import {getUserRolesText} from 'vue-common/components/utils'

export default {
  components: {
    ItemList
  },

  props: {
    searchBarText: String
  },

  data () {
    return {
      endpoint: ENDPOINT,
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: true
        },
        {
          text: 'Username',
          value: 'username',
          sortable: true
        },
        {
          text: 'Roles',
          value: 'roles',
          function: this.rolesToText,
          context: ENDPOINT + 'roles',
          sortable: true
        }
      ]
    }
  },

  methods: {
    rolesToText: function (user, roles) {
      return getUserRolesText(user.roles, roles)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Users.vue